import React, { Component } from 'react';
import logo from './img/dirad_logo.png';
var ReactSuperSelect = require('react-super-select')

export class Enrollment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            locations: [],
            error: false,
            errorBg: 0,
            step: 0,
            info: {
                'Location': [],
                'First Name': '',
                'Last Name': '',
                'Phone 1': '',
                'Phone 2': '',
                'Phone 3': '',
                'SMS 1': '',
                'SMS 2': '',
                'SMS 3': '',
                'Email 1': '',
                'Email 2': '',
                'Email 3': ''
            },
            email: "",
            code: ""
        };
    }

    next = (e) => {
        switch (this.state.step) {
            case 0:
                this.setState({ loading: true }, async () => {
                    var response = await fetch(window.location.origin + '/enrollment?email=' + this.state.email)
                    if (!response.ok) {
                        this.setState({ step: 0, loading: false, error: await response.text() })
                    } else {
                        this.setState({ step: 1, loading: false, error: null })
                    }
                });
                break
            case 1:
                this.setState({ loading: true }, async () => {
                    var response = await fetch(window.location.origin + '/enrollmentVerify?email=' + this.state.email + '&code=' + this.state.code)
                    if (!response.ok) {
                        this.setState({ step: 1, loading: false, error: await response.text() })
                    } else {
                        var body = await response.text()
                        body = JSON.parse(body)
                        this.setState({ step: 2, loading: false, code: body.code, info: body, error: null })
                    }
                });
                break
            case 2:
                if (this.state.info.Location.length < 1) {
                    this.setState({ loading: false, error: 'Please select at least 1 location.' })
                    return false
                }
                if (this.state.info['Phone 1'].length < 10) {
                    this.setState({ loading: false, error: 'Please provide at least one 10 digit phone number.' })
                    return false
                }
                if (this.state.info['Email 1'].length < 10) {
                    this.setState({ loading: false, error: 'Please provide at least one email address.' })
                    return false
                }
                if (this.state.info['SMS 1'].length < 10) {
                    this.setState({ loading: false, error: 'Please provide at least one 10 digit SMS number.' })
                    return false
                }
                if ((this.state.info['Phone 1'] && this.state.info['Phone 1'].length < 10) || (this.state.info['Phone 2'] && this.state.info['Phone 2'].length < 10) || (this.state.info['Phone 3'] && this.state.info['Phone 3'].length < 10)) {
                    this.setState({ loading: false, error: 'Make sure all provided phone numbers are 10 digits.' })
                    return false
                }
                if ((this.state.info['SMS 1'] && this.state.info['SMS 1'].length < 10) || (this.state.info['SMS 2'] && this.state.info['SMS 2'].length < 10) || (this.state.info['SMS 3'] && this.state.info['SMS 3'].length < 10)) {
                    this.setState({ loading: false, error: 'Make sure all provided SMS numbers are 10 digits.' })
                    return false
                }
                if (
                    (this.state.info['Email 1'] &&
                        (!this.state.info['Email 1'].length > 3 ||
                            !this.state.info['Email 1'].includes('@') ||
                            !this.state.info['Email 1'].includes('.')
                        )
                    ) || (this.state.info['Email 2'] &&
                        (!this.state.info['Email 2'].length > 3 ||
                            !this.state.info['Email 2'].includes('@') ||
                            !this.state.info['Email 2'].includes('.')
                        )) || (this.state.info['Email 3'] &&
                            (!this.state.info['Email 3'].length > 3 ||
                                !this.state.info['Email 3'].includes('@') ||
                                !this.state.info['Email 3'].includes('.')
                            ))
                ) {
                    this.setState({ loading: false, error: 'Make sure all email addresses are valid.' })
                    return false
                }

                this.setState({ loading: true }, async () => {
                    var response = await fetch(window.location.origin + '/enrollmentSubmit?email=' + this.state.email + '&code=' + this.state.code + '&info=' + JSON.stringify(this.state.info))
                    if (!response.ok) {
                        this.setState({ step: 2, loading: false, error: await response.text() })
                    } else {
                        this.setState({ step: 3, loading: false, error: null })
                    }
                });
                break
            default:
                break
        }
    }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.next();
        }
    }

    inputCode = (e) => {
        this.setState({ code: e.currentTarget.value.replace(/\D/gm, '').substr(0, 4) })
    }
    inputInfo = (field) => (e) => {
        var newState = JSON.parse(JSON.stringify(this.state.info))
        newState[field] = e.currentTarget.value
        this.setState({ info: newState })
    }
    inputNumber = (field) => (e) => {
        console.log(e.currentTarget.value)
        var newState = JSON.parse(JSON.stringify(this.state.info))
        newState[field] = e.currentTarget.value ? e.currentTarget.value.replace(/\D/gm, '').substr(0, 10) : ''
        this.setState({ info: newState })
    }
    selectLocation = (location) => {
        console.log(location)
        if (location) {
            var newState = JSON.parse(JSON.stringify(this.state.info))
            newState.Location = location.map((loc) => { return loc.name })
            console.log(newState.Location)
            this.setState({ info: newState })
        }
    }
    input = (field) => (e) => {
        var newState = {}
        newState[field] = e.currentTarget.value
        this.setState(newState)
    }

    async componentWillMount() {
        var response = await fetch(window.location.origin + '/locations')
        if (response.ok) {
            this.setState({ locations: await response.json() })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.setState({ loading: false, errorBg: 1 });
        }
        setTimeout(function () {
            this.setState({ errorBg: 0 });
        }.bind(this), 1000)
    }

    render() {
        if (this.state.step == 0) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />

                        <div className="snazzyInputBox" style={{ padding: '10px 0px' }}>
                            <input className="textInput" type="text" required value={this.state.email} onChange={this.input('email')} ></input>
                            <span className="inputBar"></span>
                            <label className="textLabel">Email Address</label>
                        </div>

                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Send Confirmation</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 1) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ lineHeight: '30px' }}>An email has been sent to {this.state.email} <br /> Please enter the confirmation code below.</div>

                        <div className="snazzyInputBox" style={{ width: '100px', padding: '10px 0px' }}>
                            <input style={{ textAlign: 'center' }} className="textInput" type="text" required value={this.state.code} onChange={this.inputCode} ></input>
                            <span className="inputBar"></span>
                            <label className="textLabel">Code</label>
                        </div>

                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Confirm Code</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 2) {
            var preselectedLocation = []
            if (this.state.info.Location) {
                for (var location of this.state.locations) {
                    if (this.state.info.Location.includes(location.name)) {
                        preselectedLocation.push(location)
                    }
                }
            }
            console.log(preselectedLocation)
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" style={{ maxWidth: '90vw', maxHeight: '80vh', overflow: 'auto' }} onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'visible' }}>
                            <div style={{ textAlign: 'left', flex: '1 0 95%' }}>This system will be utilized by the New York State Office of the Attorney General to notify its employees in the event of an emergency. <br /><br />

                                Please fill out the information below based on how you would like to be contacted in an emergency. You may choose multiple locations based on your work assignment. During an emergency, all forms of contact that have been entered into the system will be notified. Providing accurate contact information is extremely important so OAG can communicate with staff during an emergency.
</div>
                            <div className="snazzyInputBox" style={{ flex: '1 0 200px' }}>
                                <ReactSuperSelect initialValue={preselectedLocation} closeOnSelectedOptionClick={false} customSelectedValueTemplateFunction={(selected) => { if (selected.length < 2) { return selected[0].name } else { return selected.length + " Locations Selected" } }} searchable={true} keepOpenOnSelection={true} multiple={true} placeholder="Select a Location" style={{ flex: '1 0 150px', margin: '0px' }} dataSource={this.state.locations} onChange={this.selectLocation} />
                                <label style={{ top: '-60px', fontSize: '18px', color: '#2A6AA9' }} className="textLabel">Location</label>
                            </div>
                        </div>
                        <hr />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
                            <div key="37" className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['First Name']} onChange={this.inputInfo('First Name')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">First Name</label>
                            </div>

                            <div key="38" className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Last Name']} onChange={this.inputInfo('Last Name')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Last Name</label>
                            </div>
                        </div>
                        <hr />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
                            <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['SMS 1']} onChange={this.inputNumber('SMS 1')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">SMS 1</label>
                            </div>

                            {this.state.info['SMS 1'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['SMS 2']} onChange={this.inputNumber('SMS 2')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">SMS 2</label>
                            </div> : ''}

                            {this.state.info['SMS 2'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['SMS 3']} onChange={this.inputNumber('SMS 3')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">SMS 3</label>
                            </div> : ''}
                        </div>
                        <hr />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
                            <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Email 1']} onChange={this.inputInfo('Email 1')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Email 1</label>
                            </div>

                            {this.state.info['Email 1'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Email 2']} onChange={this.inputInfo('Email 2')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Email 2</label>
                            </div> : ''}

                            {this.state.info['Email 2'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Email 3']} onChange={this.inputInfo('Email 3')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Email 3</label>
                            </div> : ''}
                        </div>
                        <hr />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
                            <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Phone 1']} onChange={this.inputNumber('Phone 1')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Phone 1</label>
                            </div>

                            {this.state.info['Phone 1'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Phone 2']} onChange={this.inputNumber('Phone 2')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Phone 2</label>
                            </div> : ''}

                            {this.state.info['Phone 2'] ? <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.info['Phone 3']} onChange={this.inputNumber('Phone 3')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Phone 3</label>
                            </div> : ''}
                        </div>
                        <hr />


                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Submit Information</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 3) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ lineHeight: '30px' }}>Thanks! Your information has been saved successfully.</div>
                    </div>
                </div>
            )
        }
    }
}
